import { TOTAL_DAYS, BONUS_DAYS, getBonusMultiplier, DAILY_ALLOCATION } from './constants';
import { getDayStartDate, getDayEndDate } from './timerUtils';

export const calculateDailySupply = (day) => {
    const baseSupply = DAILY_ALLOCATION;
    const bonusMultiplier = getBonusMultiplier(day);
    return baseSupply * bonusMultiplier;
};

// Get day status based on current date (today, past, future)
export const getDayStatus = (day) => {
    const now = new Date();
    const dayStart = getDayStartDate(day);
    const dayEnd = getDayEndDate(day);

    if (now >= dayStart && now < dayEnd) return 'today';
    if (now < dayStart) return 'future';
    return 'past';
};

// Get day status based on current day number (active, past, future)
export const getDayStatusByNumber = (day, currentDay) => {
    if (day === currentDay) return 'active';
    if (day < currentDay) return 'past';
    return 'future';
};

export const isValidContributionDay = (day, currentDay) => {
    return day >= currentDay && day <= TOTAL_DAYS;
};

// Check if a day is a bonus day
export const isBonus = (day) => {
    return day <= 50;
};
